import store from "@/store";
import Helptopics from "../services/api/helpTopics";

export function getStyle(statusCode: string): string {
  try {
    statusCode = statusCode || '';
    if (statusCode.includes('#')) {
      return `color:${statusCode}`;
    }
    switch (statusCode.toUpperCase()) {
      case 'S':
      case 'CREDIT':
        return 'color:#34a853';
      case 'F':
      case 'DEBIT':
        return 'color:#ea4335';
      case 'P':
      case 'U':
        return 'color:#fbbc05';
      default:
        return '';
    }
  } catch (e) {
    console.error(e);
  }
}

export function formatDate(date: string) {
  try {
    return date
      .split('-')
      .reverse()
      .join('-');
  } catch (e) {
    console.error(e);
  }
}

function imageMap(serviceName: string): string {
  switch (serviceName) {
    case 'BBPS':
      return 'bbps.png';
    case 'AEPS':
      return 'aeps_withdraw_new.png';
    case 'RECHARGE':
      return 'mobile_dash.png';
    case 'DMT-SPICE MONEY':
    case 'DMT-IBL':
    case 'DMT-FINO':
    case 'DMT-YBL':
      return 'dmt_generic.png';
    case 'MPOS':
      return 'mpos_icon.png';
    case 'MATM':
      return 'spice_atm.png';
    case 'KCC':
      return 'kcc_ico.png';
    case 'CASH COLLECTION':
    case 'CASH DROP':
      return 'cash_deposit.png';
    case 'HAPPY LOAN':
    case 'LOAN':
      return 'loan_ico.png';
    case 'GOLD':
      return 'gold_new.png';
    case 'FLIGHT':
      return 'flight.png';
    case 'PAN CARD':
      return 'apply_pan.png';
    case 'MOVE TO BANK':
      return 'ic_aeps_settlement.png';
    default:
      return 'no_operator_bg_default.png';
  }
}

export function onImageError(event: any, value: string) {
  try {
    event.target.src = require(`@/assets/images/${imageMap(value.trim())}`);
  } catch (e) {
    event.target.src = require(`@/assets/images/no_operator_bg_default.png`);
  }
}

export function getLanguage(lang: string): string {
  let currLanguage = lang && lang.toUpperCase();
  switch (currLanguage) {
    case "HI":
      return "Hindi";
    case "EN":
      return "English";
    case "AS":
      return "Asamiya";
    case "BN":
      return "Bangla";
    case "GU":
      return "Gujarati";
    case "KN":
      return "Kannada";
    case "TA":
      return "Tamil";
    case "ML":
      return "Malayalam";
    case "MR":
      return "Marathi";
    case "OR":
      return "Odiya";
    case "PA":
      return "Punjabi";
    case "TE":
      return "Telugu";
    default:
      return "English";
  }
}

export function getLanguageCode(lang: string): string {
  let currLanguage = lang && lang.toUpperCase();
  switch (currLanguage) {
    case "HINDI":
      return "HI";
    case "ENGLISH":
      return "EN";
    case "ASAMIYA":
      return "AS";
    case "BANGLA":
      return "BN";
    case "GUJARATI":
      return "GU";
    case "KANNADA":
      return "KN";
    case "TAMIL":
      return "TA";
    case "MALAYALAM":
      return "ML";
    case "MARATHI":
      return "MR";
    case "ODIYA":
      return "OR";
    case "PUNJABI":
      return "PA";
    case "TELUGU":
      return "TE";
    default:
      return "EN";
  }
}

export const getLang = (lang) => {
  if (lang === null || lang === undefined) {
    lang = "EN";
  } else {
    lang = lang.toUpperCase();
  }
  return lang;
};

export const checkHelpTopic = (callback) => {
  let categories = store.state.mainCategoryInfo.mainCategoryID
    ? store.state.mainCategoryInfo.mainCategoryID
    : null;

  let subCatOne = store.state.levelOneCategory.levelOneCategoryID
    ? store.state.levelOneCategory.levelOneCategoryID
    : null;

  let subCatTwo = store.state.levelTwoCategory.levelTwoCategoryID
    ? store.state.levelTwoCategory.levelTwoCategoryID
    : null;

  let subCatThree = store.state.levelThreeCategory.levelThreeCategoryID
    ? store.state.levelThreeCategory.levelThreeCategoryID
    : null;

  let subCatFour = store.state.levelFourCategory.levelFourCategoryID
    ? store.state.levelFourCategory.levelFourCategoryID
    : null;

  let productRelated = store.state.productRelated;
  let langCode = store.state.lang;

  let lang = getLanguage(langCode);

  let helpTopicParam = {
    popular: null,
    categories: categories,
    sub_categories_1: productRelated ? subCatOne : null,
    sub_categories_2: subCatTwo,
    sub_categories_3: subCatThree,
    sub_categories_4: subCatFour,
    language: lang,
  };

  Helptopics.helpTopics(helpTopicParam).then((response) => {
    store.commit("setHelpTopics", response.data);
    callback(response.data);
  });
};

export const getHelpTopicLength = (callback) => {
  checkHelpTopic(callback);
};
